import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./TryProduct.module.css";
import Button from "common-ui-components/components/button/Button";
import { enterpriseProducts, mspProducts, PRODUCT_CONFIG, Products } from "ProductConfig";
import ResponseLoader from "common-ui-components/components/ResponseLoader/ResponseLoader";
import API from "common-ui-components/components/utils/API";
import { IAM_API } from "common-ui-components/components/utils/IAM_API";
import { UserDetailsContext } from "App";
import { notify } from "common-ui-components/components/notification/Notification";
import { Failure, Success } from "common-ui-components/components/notification/templates";
import { PRODUCT_CONTEXT } from "common-ui-components/components/utils/Config";
import MailToSuperAdmin from "app/common/mail-to/MailToSuperAdmin";
import { getProductFromPath, getUserProducts } from "Main";

const TryProduct = () => {
    const userDetails = useContext(UserDetailsContext);
    const product = PRODUCT_CONTEXT;
    const productText = Products[product] || "Endpoint Manager";
    const [loading,setLoading]=useState(false);
    const [verifying,setVerifying]=useState(true);

    const getUserDetailsForFetchingProfileInfo=async()=>{
        try
        {
            const response = await API.get("/UM/getUserDetails", {
                params: {
                    productId: 1
                }
            });
            if (response.status?.success) 
                userDetails.setUserDetails(response.body);
        }
        catch (error) 
        {
            console.error(error)
        }
        finally
        {
            setVerifying(false);
        }
    }

    const getUserDetails=async()=>{
        setVerifying(true)
        try 
        {
            const response = await API.get("/UM/getUserDetails", { no406Redirect: true });
            if (response.status?.success) 
                window.location.href=`/${product}`;
            else
                getUserDetailsForFetchingProfileInfo();
        } 
        catch (error) 
        {
            console.error(error);
            getUserDetailsForFetchingProfileInfo();
        }
    }

    const hasChecked = useRef(false);
    useEffect(async() => {
        const currentPath = window.location.pathname;
        const userProducts = await getUserProducts();
        const orgProducts = Object.keys(userProducts).filter(key => userProducts[key] === true);
        const isMspAccount = orgProducts.some(item => item.includes("msp"));
        if(isMspAccount && enterpriseProducts.includes(getProductFromPath(currentPath)))
        {
            window.location.href = `/${orgProducts[0]}`;
            return;
        }
        const isEnterpriseAccount = orgProducts.some(item => !item.includes("msp"));
        if(isEnterpriseAccount && mspProducts.includes(getProductFromPath(currentPath)))
        {
            window.location.href = `/${orgProducts[0]}`;
            return;
        }
        if (hasChecked.current) 
            return;
        hasChecked.current = true;
        const is406Redirected = sessionStorage.getItem("406RedirectedToTryProductPage");
        if (is406Redirected === "true") 
        {
            getUserDetailsForFetchingProfileInfo();
            sessionStorage.removeItem("406RedirectedToTryProductPage"); 
            return;
        }
        getUserDetails();
    }, []);

    const handleTryNow=async()=>{
        setLoading(true);
        try 
        {
            const response = await IAM_API.post(`/user/registration/try-now?pId=${PRODUCT_CONFIG[product].id}`);
            if(response.data.status.code===80)
            {
                notify(<Failure>Already the product {productText} was activated</Failure>);
                window.location.href=`/${product}`;
                return;
            }

            if(response.data.status.success)
            {
                notify(<Success>Successfully activated {productText}</Success>)
                window.location.href=`/${product}`;
            } 
            else
            {
                notify(<Failure>An error occured. Please try agin later</Failure>)
            }
        } 
        catch (error) 
        {
            console.error(error);
        } 
        finally 
        {
            setLoading(false);
        }
    }

    if(verifying) return <ResponseLoader fullScreen text="Loading" />
    
    return (
        <div className={styles.container}>
            <div className={styles.content}> 
                <h2 className={styles.title}>Welcome to Zecurit {productText}</h2>
            <p className={styles.subtitle}>
                You are just one step away from using the product !
            </p>

            {userDetails.roleName==="Super Admin" ?
                (<Button 
                    children={"Try Now"} 
                    onClick={()=>handleTryNow()} 
                    variant={"primary"} 
                    loading={loading}
                />):
                (<p>
                    Contact your Super Admin <MailToSuperAdmin /> for the access.
                </p>)
            }
            </div>
        </div>
    );
};

export default TryProduct;
